import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Collapse,
  useMediaQuery,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ChangeEvent, useState } from 'react';
import posthog from '../../../../utils/posthog';

interface ApplicationSelectionProps {
  availableApplications: string[];
  handleCheckboxChange?: (
    elem: string,
    setList: React.Dispatch<React.SetStateAction<string[]>>,
    list: string[],
    paramKey: string
  ) => (event: ChangeEvent<HTMLInputElement>) => void;
  applicationsList: string[];
  setApplicationsList: React.Dispatch<React.SetStateAction<string[]>>;
  itemGroup: string;
  applyFiltersForApplications: (applications: string[]) => void;
  hideActivePills?: boolean;
}

const ApplicationSelection = ({
                                availableApplications,
                                applicationsList,
                                setApplicationsList,
                                itemGroup,
                                applyFiltersForApplications,
                                hideActivePills = false,
                              }: ApplicationSelectionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleApplicationChange = (applicationName: string) => (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      posthog.capture('filter_applied', {
        filter_type: 'application',
        filter_value: applicationName,
        source: 'consumer',
      });
    }

    let updatedList: string[] = [...applicationsList];

    if (isChecked) {
      if (itemGroup === '005') {
        if (applicationName === 'Curtaining') {
          updatedList = updatedList.filter((app) => app !== 'Upholstery');
          if (!updatedList.includes('Curtaining')) updatedList.push('Curtaining');
          if (!updatedList.includes('Dual Purpose')) updatedList.push('Dual Purpose');
        } else if (applicationName === 'Upholstery') {
          updatedList = updatedList.filter((app) => app !== 'Curtaining');
          if (!updatedList.includes('Upholstery')) updatedList.push('Upholstery');
          if (!updatedList.includes('Dual Purpose')) updatedList.push('Dual Purpose');
        } else if (applicationName === 'Dual Purpose') {
          updatedList = ['Dual Purpose'];
        }
      } else {
        if (!updatedList.includes(applicationName)) {
          updatedList.push(applicationName);
        }
      }
    } else {
      if (itemGroup === '005') {
        if (applicationName === 'Curtaining') {
          updatedList = updatedList.filter((app) => app !== 'Curtaining');
          if (!updatedList.includes('Upholstery')) {
            updatedList = updatedList.filter((app) => app !== 'Dual Purpose');
          }
        } else if (applicationName === 'Upholstery') {
          updatedList = updatedList.filter((app) => app !== 'Upholstery');
          if (!updatedList.includes('Curtaining')) {
            updatedList = updatedList.filter((app) => app !== 'Dual Purpose');
          }
        } else if (applicationName === 'Dual Purpose') {
          updatedList = [];
        }
      } else {
        updatedList = updatedList.filter((app) => app !== applicationName);
      }
    }

    setApplicationsList(updatedList);
    applyFiltersForApplications(updatedList);
  };

  return (
    <Box sx={{ mt: '1.5rem', borderBottom: isMobile ? '1px solid #f0f0f0' : 'none', pb: isMobile ? 1 : 0 }}>
      <Box
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', mb: isMobile ? 1 : 2 }}
      >
        <Typography fontWeight="bold" fontSize="18px" mb={0}>
          Applications
        </Typography>
        <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </Box>
      </Box>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <FormGroup sx={{ overflowY: 'auto', maxHeight: '20.5rem' }}>
          {availableApplications
            ?.sort()
            .map((elem: string) => (
              <FormControlLabel
                key={elem}
                control={
                  <Checkbox
                    checked={applicationsList.includes(elem)}
                    onChange={handleApplicationChange(elem)}
                  />
                }
                label={elem}
              />
            ))}
        </FormGroup>
      </Collapse>
    </Box>
  );
};

export default ApplicationSelection;